<template>
  <div v-if="tool" class="tool-form">
    <div class="display-2 font-weight-bold mb-6 text-capitalize">
      {{ tool.name }}
    </div>

    <v-row>
      <v-col cols="8">
        <v-form ref="form" style="max-width: 600px">
          <v-row>
            <v-col cols="12" sm="6">
              <label class="text-field-label">Owner</label>
              <v-text-field
                v-model="owner.full_name"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <label class="text-field-label">Added Date</label>
              <v-text-field
                v-model="tool.addedDate"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6">
              <label class="text-field-label">Price</label>
              <v-text-field
                v-model="tool.price"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <label class="text-field-label">Description</label>
              <v-textarea
                v-model="tool.description"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12">
              <label class="text-field-label">Address</label>
              <v-text-field
                v-model="tool.address_1"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <label class="text-field-label">City or Suburb</label>
              <v-text-field
                v-model="tool.city"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <label class="text-field-label">Postcode</label>
              <v-text-field
                v-model="tool.postal_code"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6">
              <label class="text-field-label">Country</label>
              <v-text-field
                v-model="tool.country"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6">
              <label class="text-field-label">State</label>
              <v-text-field
                v-model="tool.state"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col cols="4">
        <v-card style="max-width: 300px;">
          <v-card-title class="subheading font-weight-bold">
            Photos ({{ photos.length }})
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col cols="6" v-for="photo in photos" :key="photo.id">
                <v-img :src="photo.thumb_url" />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Job from '@/models/Job'

export default {
  props: {
    tool: {
      type: [Job, Object]
    }
  },

  computed: {
    owner() {
      return this.tool && this.tool.owner ? this.tool.owner : {}
    },

    photos() {
      return this.tool && this.tool.gallery ? this.tool.gallery : []
    }
  }
}
</script>
